import banner from "../../../courses/module-2/img7.png";

const modulo7 = {
  courseId: "cripto-blockchain",
  id: "modulo-7",
  title: "🧩 MODULE 7: Learn and Earn Crypto – Education with Real Rewards",
  estimatedDuration: "45 minutes",
  format: "Reading + reflective activity",
  bannerUrl: banner,
  sections: [
    {
      id: "que-es",
      navLabel: "What is Learn & Earn?",
      title: "🎯 What is Learn & Earn?",
      content: [
        {
          type: "paragraph",
          text: "Learn & Earn is an educational model where users receive small cryptocurrency rewards in exchange for learning about Web3 projects.",
        },
        {
          type: "paragraph",
          text: "Instead of only studying theory, this model offers:",
        },
        {
          type: "list",
          items: [
            "Practical mini-lessons, usually in video or interactive text format.",
            "Quizzes or challenges that test your understanding.",
            "Token rewards, sent directly to your wallet after completing each activity.",
          ],
        },
        {
          type: "paragraph",
          text: "It is an excellent way to learn while earning, without needing any previous investment. Ideal for young people who are just starting in the crypto world.",
        },
      ],
    },
    {
      id: "funcionamiento",
      navLabel: "How does it work?",
      title: "📚 How does it work?",
      content: [
        {
          type: "orderedList",
          items: [
            "You create an account on a platform that offers Learn & Earn.",
            "You choose an active lesson, for example: “What is Polygon (MATIC)?”.",
            "You study the content, such as a video, article, or infographic.",
            "You answer a short quiz.",
            "You receive a fraction of that cryptocurrency, usually between $1 and $3 USD in tokens.",
          ],
        },
        {
          type: "paragraph",
          text: "💡 These rewards work as an incentive and also allow you to practice how a wallet, a network, and real tokens work.",
        },
      ],
    },
    {
      id: "plataformas",
      navLabel: "Popular platforms",
      title: "🌐 Popular platforms",
      content: [
        {
          type: "paragraph",
          text: "✅ Coinbase Learn & Earn",
        },
        {
          type: "list",
          items: [
            "Platform: Coinbase Learn & Earn",
            "Language: English, with some courses offering subtitles",
            "Rewards: USDC, MATIC, XLM, among others.",
            "Requirements: Identity verification (KYC) and an active Coinbase account.",
            "Advantages: Recognized platform and easy to use for beginners.",
          ],
        },
        {
          type: "paragraph",
          text: "✅ Binance Learn & Earn",
        },
        {
          type: "list",
          items: [
            "Platform: Binance Learn & Earn",
            "Language: Spanish, English, and others.",
            "Rewards: Vary depending on the project, such as ALGO, BNB, SUI, etc.",
            "Requirements: Verified Binance account. Some campaigns require BNB staking.",
            "Advantages: Frequent offers. Friendly and secure interface.",
          ],
        },
        {
          type: "paragraph",
          text: "✅ Stellar Quest",
        },
        {
          type: "list",
          items: [
            "Platform: Stellar Quest",
            "Language: English, with visual explanations.",
            "Rewards: XLM (Stellar Lumens).",
            "Requirements: Create a compatible wallet, such as Freighter, and complete technical challenges.",
            "Advantages: Ideal for people who want to learn by doing. It teaches technical concepts from level 0, such as creating and signing transactions on the Stellar network.",
          ],
        },
      ],
    },
    {
      id: "consideraciones",
      navLabel: "What to keep in mind?",
      title: "⚠️ What should you keep in mind before participating?",
      content: [
        {
          type: "list",
          items: [
            "Always verify that the website is official. There are fake sites that imitate real platforms.",
            "Never share your seed phrase, even if someone promises you more rewards.",
            "Read the terms of each campaign. Some are only available in certain countries or for a limited time.",
            "Use secure emails and protected wallets. Your security is your responsibility!",
          ],
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Activity",
      title: "📝 Activity – Learn and reflect",
      content: [
        {
          type: "orderedList",
          items: [
            "Choose an active mini-lesson from one of the recommended platforms above.",
            "Complete the quiz and receive your first crypto reward.",
            "Then, in your notebook, answer:",
          ],
        },
        {
          type: "list",
          items: [
            "What did you learn about that project?",
            "Was it easy or difficult for you to understand it?",
            "What would you do with the small amount you earned?",
            "Do you think this model motivates young people to learn more about finance and technology?",
          ],
        },
      ],
    },
    {
      id: "ejemplo",
      navLabel: "Real example",
      title: "📌 Real example",
      content: [
        {
          type: "paragraph",
          text: "🌟 María, a 20-year-old student in Mexico, completed three lessons on Coinbase Learn. She earned $6 USD in USDC. Then she used it to try her first wallet and make a transfer between friends. She had never owned cryptocurrencies before. Today, she keeps learning and is already considering saving part of her scholarship in stablecoins.",
        },
      ],
    },
    {
      id: "frase",
      navLabel: "Final quote",
      title: "🧠 Final quote",
      content: [
        {
          type: "paragraph",
          text: "“In Web3, even your learning can have value. Every lesson you complete brings you closer to financial freedom.”",
        },
      ],
    },
  ],
};

export default modulo7;
